/* eslint-disable no-restricted-globals */
import { useSyncExternalStore } from 'react';

// History patching is done in index.js (runs before Router)

function subscribe(callback) {
  window.addEventListener('popstate', callback);
  window.addEventListener('pushstate', callback);
  window.addEventListener('replacestate', callback);
  return () => {
    window.removeEventListener('popstate', callback);
    window.removeEventListener('pushstate', callback);
    window.removeEventListener('replacestate', callback);
  };
}

function getSnapshot() {
  return window.location.pathname;
}

export function usePathname() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
